import React from "react";
import {
  Home,
  ShoppingCart,
  FileText,
  DollarSign,
  Settings,
  LogOut,
  ChevronLeft,
  ChevronRight,
  FileSpreadsheet,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { signOut } from "firebase/auth";
import { auth } from "../../firebaseConfig";

const ClientSidebar = ({ isOpen, onToggle }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.clear();
      navigate("/login");
    } catch (error) {
      console.error("Error signing out:", error);
      // Still navigate to login even if signOut fails
      localStorage.clear();
      navigate("/login");
    }
  };

  const menuItems = [
    { name: "Dashboard", icon: <Home size={20} />, path: "/client-dashboard" },
    { name: "Orders", icon: <ShoppingCart size={20} />, path: "/client/orders" },
    { name: "Invoices", icon: <FileText size={20} />, path: "/client/invoices" },
    { name: "Payments", icon: <DollarSign size={20} />, path: "/client/payments" },
    { name: "Earn Money", icon: <FileSpreadsheet size={20} />, path: "/annotation-marketplace" },
    { name: "Settings", icon: <Settings size={20} />, path: "/client/settings" },
  ];

  return (
    <div className="h-full flex flex-col justify-between">
      {/* Top section */}
      <div>
        <div className="flex items-center justify-between p-4 border-b">
          <motion.h1
            initial={{ opacity: 0 }}
            animate={{ opacity: isOpen ? 1 : 0 }}
            className="text-lg font-bold text-yellow-700"
          >
            Client
          </motion.h1>
          <button onClick={onToggle} className="text-yellow-600 hover:text-yellow-800">
            {isOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
          </button>
        </div>

        {/* Menu */}
        <nav className="mt-4">
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="flex items-center gap-3 px-4 py-2 text-gray-700 hover:bg-yellow-50 hover:text-yellow-700 transition-colors"
            >
              {item.icon}
              {isOpen && <span>{item.name}</span>}
            </Link>
          ))}
        </nav>
      </div>

      {/* Logout button */}
      <div className="p-4 border-t">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 text-red-600 hover:bg-red-50 px-4 py-2 rounded-md w-full"
        >
          <LogOut size={20} />
          {isOpen && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default ClientSidebar;
